import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { DateTime } from 'luxon';

import { Button } from '../../../design-system';
import SectionWrapper from '../SectionWrapper/SectionWrapper';

const ActivityLogBlock = ({ activityLogData, organizationId }) => {
    const navigate = useNavigate();

    if (!activityLogData) return null;

    const { count, results } = activityLogData;

    const areResults = !!results.length;

    return (
        <SectionWrapper title="Activity Log">
            <div className="flex flex-col gap-4">
                {areResults && (
                    <ul className="flex flex-col gap-2">
                        {results.map((log) => {
                            const { activity_id, activity_display, created_by_email, created_at } =
                                log;
                            const timestamp =
                                DateTime.fromISO(created_at).toFormat('MM/dd/yyyy @ h:mm a');

                            return (
                                <li
                                    key={activity_id}
                                    className="max-w-full py-1 flex flex-col xs:flex-row xs:items-center justify-between gap-2 xs:gap-4 border-b-1 border-neutral-200"
                                >
                                    <p
                                        className="font-body text-body-regular-s text-neutral-500 overflow-hidden"
                                        style={{ overflowWrap: 'break-word' }}
                                    >
                                        <span className="font-body-bold text-body-bold-s">
                                            {activity_display}
                                        </span>{' '}
                                        by {created_by_email}
                                    </p>

                                    <p className="font-body text-body-regular-xs text-neutral-300 whitespace-nowrap">
                                        {timestamp}
                                    </p>
                                </li>
                            );
                        })}
                    </ul>
                )}

                {!areResults && (
                    <p className="font-body text-body-regular-m text-neutral-500">
                        No Activity Logs found
                    </p>
                )}

                {count > 3 && (
                    <div>
                        <Button
                            type="primary"
                            size="xs"
                            text="View All"
                            onClick={() =>
                                navigate(`/settings/organization/${organizationId}/activity`)
                            }
                        />
                    </div>
                )}
            </div>
        </SectionWrapper>
    );
};

export default memo(ActivityLogBlock);
